import gql from 'graphql-tag';

export default gql`
    query GetLoadIdByDriverId($driverId: Int) {
        getLoadIdByDriverId(driverId: $driverId) {
            loadId
        }
    }
`;
